import { useContext } from 'react';
import AlignContext, { inertAlignContextProps } from "./AlignContext";

const useAlignContext = () => {
  const alignContext = useContext(AlignContext);
  const isAligned = alignContext !== inertAlignContextProps;
  return {
    alignContext,
    isAligned
  };
};

export { useAlignContext };